import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import get from 'lodash/get';
import apex, { setGateway } from '../../apex';
export var CONNECTION_CLOSED_COUNT = 'CONNECTION_CLOSED_COUNT';
export var CONNECTION_CLOSED = 'CONNECTION_CLOSED';
export var CONNECTION_OPENED = 'CONNECTION_OPENED';
export var connectionOpened = function connectionOpened() {
  return {
    type: CONNECTION_OPENED,
    payload: {
      isConnected: true
    }
  };
};
export var connectionClosed = function connectionClosed() {
  return {
    type: CONNECTION_CLOSED,
    payload: {
      isConnected: false
    }
  };
};
export var connectionClosedCount = function connectionClosedCount(attemptNumber) {
  return {
    type: CONNECTION_CLOSED_COUNT,
    payload: attemptNumber
  };
};
export var pingBackend = function pingBackend() {
  return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return apex.connection.Ping();
          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));
};
export var changeServer = function changeServer(value) {
  var socket = get(apex, 'connection.ws.socket');
  if (socket) socket.close();
  if (value !== 'CUSTOM') {
    setGateway(value);
    localStorage.setItem('tradingServer', value);
  }
};